var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewPickupDetailsSectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15 3V12C15 13.1 14.1 14 13 14H2V7.62C2.73 8.49 3.85003 9.03 5.09003 9C6.10003 8.98 7.01 8.59 7.69 7.94C8 7.68 8.26002 7.34999 8.46002 6.98999C8.82002 6.37999 9.02 5.65997 9 4.90997C8.97 3.73997 8.45001 2.71 7.64001 2H14C14.55 2 15 2.45 15 3Z",
    fill: "#0066FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 14V17C22 18.66 20.66 20 19 20H18C18 18.9 17.1 18 16 18C14.9 18 14 18.9 14 20H10C10 18.9 9.1 18 8 18C6.9 18 6 18.9 6 20H5C3.34 20 2 18.66 2 17V14H13C14.1 14 15 13.1 15 12V5H16.84C17.56 5 18.22 5.39001 18.58 6.01001L20.29 9H19C18.45 9 18 9.45 18 10V13C18 13.55 18.45 14 19 14H22Z",
    fill: "#0066FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8 22C9.10457 22 10 21.1046 10 20C10 18.8954 9.10457 18 8 18C6.89543 18 6 18.8954 6 20C6 21.1046 6.89543 22 8 22Z",
    fill: "#0066FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16 22C17.1046 22 18 21.1046 18 20C18 18.8954 17.1046 18 16 18C14.8954 18 14 18.8954 14 20C14 21.1046 14.8954 22 16 22Z",
    fill: "#0066FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22 12.53V14H19C18.45 14 18 13.55 18 13V10C18 9.45 18.45 9 19 9H20.29L21.74 11.54C21.91 11.84 22 12.18 22 12.53Z",
    fill: "#0066FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64 2.00002C6.92 1.36002 5.95996 0.98002 4.90996 1.00002C3.96996 1.02002 3.10998 1.37001 2.42998 1.93001C1.52998 2.68001 0.969989 3.83005 0.999989 5.09005C1.01999 5.84005 1.23999 6.54002 1.62999 7.13002C1.73999 7.30002 1.85999 7.47001 1.99999 7.62001C2.72999 8.49001 3.85002 9.03002 5.09002 9.00002C6.10002 8.98002 7.00999 8.59002 7.68999 7.94002C7.99999 7.68002 8.26001 7.35001 8.46001 6.99001C8.82001 6.38001 9.01999 5.65999 8.99999 4.90999C8.96999 3.73999 8.45 2.71002 7.64 2.00002ZM7.05999 4.52004L4.96996 6.54C4.81996 6.68 4.64 6.75002 4.45 6.75002C4.26 6.75002 4.07998 6.68 3.92998 6.54L2.91997 5.58004C2.61997 5.29004 2.61001 4.82004 2.90001 4.52004C3.19001 4.22004 3.66001 4.21002 3.96001 4.50002L4.45 4.96999L6.02001 3.45003C6.32001 3.16003 6.79001 3.16999 7.08001 3.46999C7.37001 3.75999 7.35999 4.23004 7.05999 4.52004Z",
    fill: "#0066FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPickupDetailsSectionIcon);
export default __webpack_public_path__ + "554e7abddd08e381a20a8db51f6d6af8.svg";
export { ForwardRef as ReactComponent };